export const insightsDate = (day) => day?.split('-').reverse().join('/') || '—';
export const km = (metres) => (Number(metres || 0) / 1000).toLocaleString('en-IN', { maximumFractionDigits: 1 });
export const hours = (ms) => (Number(ms || 0) / 3600000).toFixed(1);
export const percent = (value) => (value == null ? 'Unavailable' : `${Number(value).toFixed(1)}%`);
export const insightsRange = (days, now = new Date()) => {
  // Calendar dates in India, independent of the browser's timezone or daylight saving.
  const india = new Date(now.getTime() + 330 * 60000);
  const end = Date.UTC(india.getUTCFullYear(), india.getUTCMonth(), india.getUTCDate()) - 86400000;
  return { from: new Date(end - (days - 1) * 86400000).toISOString().slice(0, 10), to: new Date(end).toISOString().slice(0, 10) };
};
